import { getSheetInfomations } from "./methods/getSheetInfomations";
import { getIntervalLimit } from "./methods/getIntervalLimit";

export default {
  getSheetInfomations,
  getIntervalLimit,
};
